var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"btn",class:_vm.clsx(( _obj = {
    'btn--loading': _vm.isLoading,
    'btn--disabled': _vm.isDisabled
  }, _obj[("btn--size-" + _vm.size)] = true, _obj )),attrs:{"disabled":_vm.isDisabled || _vm.isLoading}},_vm.$listeners),[(!_vm.isLoading)?_c('span',{staticClass:"btn__label"},[_vm._t("default")],2):_vm._e(),(_vm.isLoading)?_c('span',{staticClass:"btn__loader"},[_c('SpinnerLoader',{attrs:{"color":"#0A77FF"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }